import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text } from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "../../store";
import { moveRecruiter, fetchSingleDepartment } from "../../store/slices/departments";
import { useParams } from "react-router-dom";
import { useState } from "react";

interface MoveRecruiterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onMove: (departmentId: number) => void;
    recruiterFullName: string;
    recruiterId: number;
    isLoading?: boolean;
    departmentId?: number;
}

export const MoveRecruiterModal = ({
    isOpen,
    onClose,
    onMove,
    recruiterFullName,
    isLoading = false,
    recruiterId,
    departmentId,
}: MoveRecruiterModalProps) => {
    const dispatch = useAppDispatch();
    const { departments } = useAppSelector(state => state.departments);
    const { id } = useParams();
    const effectiveDepartmentId = departmentId ?? (id ? Number(id) : undefined);

    const [selectedDepartmentId, setSelectedDepartmentId] = useState<number | "">("");

    const handleMove = () => {
        if (!selectedDepartmentId || !recruiterId) return;
        dispatch(moveRecruiter({
            param: {
                department_id: selectedDepartmentId
            },
            data: {
                recruiter_id: recruiterId
            }
        }))
            .finally(() => {
                if (effectiveDepartmentId) dispatch(fetchSingleDepartment(effectiveDepartmentId));
                onMove(selectedDepartmentId);
                onClose();
            });
    };

    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose}>
            <ModalOverlay backdropFilter="blur(3px)" />
            <ModalContent maxW="50vw" gap="24px" px="24px" paddingTop="32px" paddingBottom="24px">
                <ModalHeader p={0}>Переместить сотрудника</ModalHeader>
                <ModalBody>
                    <Text mb={4}>Переместить сотрудника <b>{recruiterFullName}</b> в другое подразделение</Text>
                    <Text mb={2}>Выберите подразделение:</Text>
                    <Select
                        id="move-recruiter-department"
                        placeholder="Выберите подразделение..."
                        value={selectedDepartmentId}
                        onChange={(e) => setSelectedDepartmentId(e.target.value ? Number(e.target.value) : "")}
                    >
                        {departments.items.map((dept) => (
                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                        ))}
                    </Select>
                </ModalBody>
                <ModalFooter p={0} pt="8px">
                    <Flex gap="12px">
                        <Button variant="outline" onClick={onClose}>Отмена</Button>
                        <Button colorScheme="blue" onClick={handleMove} isDisabled={!selectedDepartmentId} isLoading={isLoading}>Переместить</Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};


